import i18n from '../../language/index'

export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    lineHeight: i18n.t('view_back_top_edit_103'),
    fontSize: 20,
    fsWeight: 'normal',
    fsItalics: 'normal',
    fontStyle: '',
    fontUnderline: 'none',
    fontFamily: 'Arial',
    titleColor: 'rgba(51, 51, 51,1)',
    textAlign: 'left',
    background: 'rgba(252, 255, 255,1)',
    selectValue1: 'default'
  },
  mb_widgets_infor: {},
  listArr: {
    title: i18n.t('widgets_basic_h1_style_576'),
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_h1/style.js